/**
 * YearContext — выбранный год данных (селектор в Header).
 *
 * `selectedYear === null` — «последние данные»: параметр year в запросы
 * не передаётся, бэк отдаёт последний доступный год по территории (FR-7,
 * фактический год приходит в поле `year` ответа). Выбор года пробрасывают
 * в запросы страницы «Аналитики», ЦП и сайдбара.
 *
 * Контекст с безопасным дефолтом (не бросает вне провайдера): страницы
 * рендерятся в тестах без обёртки — там действует режим «последние данные».
 */
import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';

interface YearContextValue {
  selectedYear: number | null;
  setSelectedYear: (year: number | null) => void;
}

const YearContext = createContext<YearContextValue>({
  selectedYear: null,
  setSelectedYear: () => undefined,
});

export const YearProvider = ({ children }: { children: ReactNode }) => {
  const [selectedYear, setSelectedYear] = useState<number | null>(null);
  const value = useMemo(
    () => ({ selectedYear, setSelectedYear }),
    [selectedYear],
  );
  return <YearContext.Provider value={value}>{children}</YearContext.Provider>;
};

export const useYear = (): YearContextValue => useContext(YearContext);
